import {FC} from "react";
import {
  IGartnerAnalyticsData,
  IGartnerPlotsData,
  IGartnerSeriesData,
} from "../../../../pages/Dashboard/Dashboard.type";
import {GARTNER_CHART_COLORS} from "./constants";
import {GartnerLifecycleChart} from "./GartnerLifecycleChart";
import {
  GartnerEntityType,
  GartnerMetricsPanel,
  GartnerPanelHeader,
} from "./GartnerMetricsPanel";
import {GartnerSeriesChart} from "./GartnerSeriesChart";
import {
  buildPatentsSeriesChartData,
  buildScienceSeriesChartData,
} from "./utils";

interface IProps {
  entityType?: GartnerEntityType;
  entityName: string;
  clusterName?: string;
  plotsData: IGartnerPlotsData;
  analyticsData: IGartnerAnalyticsData;
  seriesData?: IGartnerSeriesData | null;
}

export const GartnerChartPanel: FC<IProps> = ({
  entityType = "technology",
  entityName,
  clusterName,
  plotsData,
  analyticsData,
  seriesData,
}) => {
  const scienceSeries = buildScienceSeriesChartData(seriesData);
  const patentsSeries = buildPatentsSeriesChartData(seriesData);

  return (
    <div style={{display: "flex", flexDirection: "column", gap: "20px"}}>
      <GartnerPanelHeader
        entityType={entityType}
        entityName={entityName}
        clusterName={clusterName}
      />
      <GartnerMetricsPanel analytics={analyticsData} />
      <GartnerLifecycleChart plotsData={plotsData} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <GartnerSeriesChart
          title="Научные публикации (мир)"
          yAxisLabel="Количество статей"
          data={scienceSeries}
          barColor={GARTNER_CHART_COLORS.scienceBar}
          lineColor="#FFFFFF"
        />
        <GartnerSeriesChart
          title="Патенты (мир)"
          yAxisLabel="Количество патентов"
          data={patentsSeries}
          barColor={GARTNER_CHART_COLORS.patentsBar}
          lineColor="#FFFFFF"
        />
      </div>
    </div>
  );
};
